import { render, staticRenderFns } from "./AccountHolderWidgetBase.vue?vue&type=template&id=4f14a7ca&scoped=true"
import script from "./AccountHolderWidgetBase.vue?vue&type=script&lang=ts"
export * from "./AccountHolderWidgetBase.vue?vue&type=script&lang=ts"
import style0 from "./AccountHolderWidgetBase.vue?vue&type=style&index=0&id=4f14a7ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f14a7ca",
  null
  
)

export default component.exports